import { j as r, c as S } from "./utils-BdNIfrGQ.js";
import { I as M } from "./BaseInput.styles-Bn99zfPn.js";
import { c as H } from "./index-Di82Y7n3.js";
import * as i from "react";
import { u as L, P as C, c as A, a as U } from "./index-wif4gfZf.js";
import { u as y } from "./index-DLcqcWxM.js";
import { u as V } from "./index-BZPx6jYI.js";
import { u as q } from "./index-BGQepRFJ.js";
import { L as z } from "./Label-kWLyCHVQ.js";
const F = H("bg-gray-600", {
  variants: {
    variant: {
      default: "data-[state=checked]:bg-dark",
      primary: "data-[state=checked]:bg-primary"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var b = "Switch", [O] = U(b), [$, D] = O(b), P = i.forwardRef(
  (t, a) => {
    const {
      __scopeSwitch: e,
      name: o,
      checked: s,
      defaultChecked: u,
      required: c,
      disabled: n,
      value: d = "on",
      onCheckedChange: v,
      form: l,
      ...w
    } = t, [p, f] = i.useState(null), k = y(a, (m) => f(m)), x = i.useRef(!1), g = p ? l || !!p.closest("form") : !0, [h, B] = L({
      prop: s,
      defaultProp: u ?? !1,
      onChange: v,
      caller: b
    });
    return /* @__PURE__ */ r.jsxs($, { scope: e, checked: h, disabled: n, children: [
      /* @__PURE__ */ r.jsx(
        C.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": h,
          "aria-required": c,
          "data-state": E(h),
          "data-disabled": n ? "" : void 0,
          disabled: n,
          value: d,
          ...w,
          ref: k,
          onClick: A(t.onClick, (m) => {
            B((T) => !T), g && (x.current = m.isPropagationStopped(), x.current || m.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ r.jsx(
        N,
        {
          control: p,
          bubbles: !x.current,
          name: o,
          value: d,
          checked: h,
          required: c,
          disabled: n,
          form: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
P.displayName = b;
var j = "SwitchThumb", R = i.forwardRef(
  (t, a) => {
    const { __scopeSwitch: e, ...o } = t, s = D(j, e);
    return /* @__PURE__ */ r.jsx(
      C.span,
      {
        "data-state": E(s.checked),
        "data-disabled": s.disabled ? "" : void 0,
        ...o,
        ref: a
      }
    );
  }
);
R.displayName = j;
var W = "SwitchBubbleInput", N = i.forwardRef(
  ({
    __scopeSwitch: t,
    control: a,
    checked: e,
    bubbles: o = !0,
    ...s
  }, u) => {
    const c = i.useRef(null), n = y(c, u), d = V(e), v = q(a);
    return i.useEffect(() => {
      const l = c.current;
      if (!l) return;
      const w = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(
        w,
        "checked"
      ).set;
      if (d !== e && f) {
        const k = new Event("click", { bubbles: o });
        f.call(l, e), l.dispatchEvent(k);
      }
    }, [d, e, o]), /* @__PURE__ */ r.jsx(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: e,
        ...s,
        tabIndex: -1,
        ref: n,
        style: {
          ...s.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
N.displayName = W;
function E(t) {
  return t ? "checked" : "unchecked";
}
var _ = P, X = R;
const I = i.forwardRef(({ className: t, ...a }, e) => /* @__PURE__ */ r.jsx(
  _,
  {
    className: S(
      "peer inline-flex h-7 w-[38px] shrink-0 cursor-pointer items-center rounded-[20px] border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-input",
      t
    ),
    ...a,
    ref: e,
    children: /* @__PURE__ */ r.jsx(
      X,
      {
        className: S(
          "pointer-events-none block h-6 w-6 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-2"
        )
      }
    )
  }
));
I.displayName = _.displayName;
const re = ({
  id: t,
  label: a,
  helperText: e,
  error: o,
  hideLabel: s,
  variant: u,
  align: c,
  ...n
}) => {
  const d = s === !0 ? "hidden" : "visible";
  return /* @__PURE__ */ r.jsxs(M, { align: c, children: [
    /* @__PURE__ */ r.jsx(z, { htmlFor: t, variant: d, helperText: e, children: a }),
    /* @__PURE__ */ r.jsx(I, { id: t, className: S(F({ variant: u })), ...n }),
    o
  ] });
};
export {
  re as S
};
